import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  DialogActions,
  Drawer,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  FormHelperText,
  useTheme,
} from "@mui/material";
import { Upload } from "@mui/icons-material";
import Header from "../../component/Header";
import {
  updateSlidersAction,
  fetchSliderAction,
  resetState,
} from "../../state/sliders/sliderSlice";
import Dropzone from "react-dropzone";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Loader from "../../component/loader";

const EditSlider = ({ open, handleClose, id }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [fileName, setFileName] = useState("No file chosen");

  const isSuccess = useSelector((state) => state.sliders.isSuccess);
  const appErr = useSelector((state) => state.sliders.appErr);
  const loading = useSelector((state) => state.sliders.loading);
  const slider = useSelector((state) => state.sliders.data);
  const Updated = useSelector((state) => state?.sliders.Updated);

  useEffect(() => {
    if (id) {
      dispatch(fetchSliderAction(id));
    }
  }, [dispatch, id, isSuccess]);

  useEffect(() => {
    if (isSuccess && Updated) {
      toast.success("Details Edited Successfully!");
    }
  }, [isSuccess, Updated]);

  useEffect(() => {
    if (appErr) {
      toast.error(appErr);
    }
  }, [appErr]);

  // Define validation schema
  const validationSchema = Yup.object().shape({
    type: Yup.string().required("Type is required"),
    src: Yup.mixed().required("Image is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      type: slider?.type || "", // Ensure that the initial value is not undefined
      src: slider?.src || null, // Set initial value appropriately
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const data = {
        type: values?.type,

        src: values?.src,
      };
      dispatch(updateSlidersAction({ data, id }));
      handleClose();
      setFileName("No file chosen");
      console.log(values);
      setSubmitting(false);
      setTimeout(() => {
        dispatch(resetState());
      }, 3000);
    },
  });

  return (
    <React.Fragment>
      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        style={{ zIndex: "9999 " }} // Default width
        PaperProps={{
          sx: {
            width: "35%", // Default width
            "@media (max-width: 700px)": {
              width: "70%", // Width set to 70% for screens <= 700px
            },
          },
        }}
      >
        <form onSubmit={formik.handleSubmit} encType="multipart/form-data">
          <Box m="1.5rem 2.5rem">
            <Box mb={3}>
              <Header title="Sliders" subtitle="Add New Slider" />
            </Box>

            <Grid container>
              <Grid item xs={12} md={12}>
                <Box
                  p={2}
                  borderRadius={4}
                  bgcolor={theme.palette.background.default}
                  boxShadow={theme.shadows[3]}
                >
                  {" "}
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Slider Type :
                  </Typography>
                  <hr
                    style={{ border: "1px solid #f0f0f0", margin: "10px 0" }}
                  />
                  <Typography variant="h6" gutterBottom>
                    Type: <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <RadioGroup
                    aria-label="slider-type"
                    name="type"
                    value={formik.values.type}
                    onChange={formik.handleChange}
                  >
                    <FormControlLabel
                      value="image"
                      control={<Radio />}
                      label="Image"
                    />
                    <FormControlLabel
                      value="video"
                      control={<Radio />}
                      label="Video"
                    />
                    {formik.touched.type && formik.errors.type && (
                      <FormHelperText>{formik.errors.type}</FormHelperText>
                    )}
                  </RadioGroup>
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box
                  p={2}
                  mt={2}
                  borderRadius={4}
                  bgcolor={theme.palette.background.default}
                  boxShadow={theme.shadows[3]}
                >
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Slider Image :
                  </Typography>
                  <hr
                    style={{ border: "1px solid #f0f0f0", margin: "10px 0" }}
                  />
                  <Typography variant="h6" gutterBottom>
                    Image: <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Dropzone
                    onDrop={(acceptedFiles) => {
                      formik.setFieldValue("src", acceptedFiles[0]);
                      setFileName(acceptedFiles[0].name);
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps()}>
                        <input {...getInputProps()} accept="image/*" />
                        <Button
                          variant="contained"
                          startIcon={<Upload />}
                          color="secondary"
                          style={{ marginTop: "18px", marginBottom: "10px" }}
                        >
                          Choose Image
                        </Button>
                      </div>
                    )}
                  </Dropzone>

                  <div style={{ color: "#d32f2f" }}>
                    {formik.touched.src && Boolean(formik.errors.src)}
                    {formik.touched.src && formik.errors.src}
                  </div>
                  <span>{fileName}</span>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <DialogActions>
            <Button
              onClick={handleClose}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="secondary"
              disabled={loading}
              size="small"
            >
              {!loading ? "Submit" : <Loader />}
            </Button>
          </DialogActions>
        </form>
      </Drawer>
    </React.Fragment>
  );
};

export default EditSlider;
